import Photo from "shared/components/data-display/media/Photo";
import Text from "shared/components/data-display/text/Text";
import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";

export const StyledPhoto = styled(Photo)`
    width: 17rem;
    height: 17rem;
    border-radius: 10rem;
    margin: 0 auto;
`;

export const StyledTextLabel = styled(Text)`
    background: ${COLOR_VALUES.Gray_1};
    text-align: center;
    text-transform: uppercase;
    background: ${COLOR_VALUES.Gray_7};
    border-radius: 2px;
    padding: 4px;
    width: max-content;
`;

export const MoreMenuContainer = styled.div`
    padding: 0.5rem 0 0 0.5rem;
`;

export const StyledCodeNumber = styled(Text)`
    white-space: pre-line;
`;
